import { TextField, InputAdornment } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { DateRange } from '../../store';
import { DateTimeFormat, getLocalDateTime } from '@src/app/utils/GenericUtils';
import DateRangePickerModal from '@components/dateRange/DateRangeModal';
import { Event } from '@mui/icons-material';

interface Props {
  dateRange: DateRange;
  inceptionDate?: string;
  isDateOnly?: boolean;
  setDateRange: (dateRange: DateRange) => void;
}

const useStyles = makeStyles(() => ({
  modalTextFieldDateRange: {
    '& input': {
      minWidth: '166px',
    },
    // apply style to firefox only
    '@supports (-moz-appearance:none)': {
      '& input': {
        minWidth: '176px',
      },
    },
  },
}));

export default function DateRangePicker(props: Props): JSX.Element {
  const classes = useStyles();
  const [openModal, setOpenModal] = React.useState(false);
  const isDateOnly = props.isDateOnly ?? false;

  const dateRangeDisplay = isDateOnly
    ? `${getLocalDateTime(props.dateRange.dateTo, DateTimeFormat.Short)}`
    : `${getLocalDateTime(props.dateRange.dateFrom, DateTimeFormat.Short)} - ${getLocalDateTime(props.dateRange.dateTo, DateTimeFormat.Short)}`;

  const dateLabel = isDateOnly ? 'Select date' : 'Select dates';

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <TextField
        onClick={handleOpenModal}
        label={dateLabel}
        variant="outlined"
        InputProps={{
          className: isDateOnly ? undefined : classes.modalTextFieldDateRange,
          endAdornment: (
            <InputAdornment position="end">
              <Event />
            </InputAdornment>
          ),
        }}
        value={dateRangeDisplay}
        sx={{
          '& .MuiOutlinedInput-root': {
            height: 40,
            fontSize: '16px',
            color: '#222222',
          },
          '& .MuiOutlinedInput-input': {
            padding: '0 12px',
            height: '40px',
            boxSizing: 'border-box',
          },
          minWidth: { md: '280px', sm: '140px', xs: '110px' },
        }}
      />
      <DateRangePickerModal
        inceptionDate={props.inceptionDate}
        isDateOnly={isDateOnly}
        open={openModal}
        dateRange={props.dateRange}
        setDateRange={props.setDateRange}
        onClose={handleCloseModal}
      />
    </>
  );
}
